
export default function CTASection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative w-full h-[400px] md:h-[480px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0f948944c83c469abc78286a02b5f106.jpg"
          alt="학원 배경"
          className="w-full h-full object-cover"
          style={{ filter: 'blur(3px)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative h-full max-w-6xl mx-auto px-5 md:px-12 flex flex-col md:flex-row items-center justify-center md:justify-between">
        <div className="flex flex-col items-center md:items-start justify-center md:justify-between h-full py-12 md:py-16 text-center md:text-left">
          <h2 className="text-3xl md:text-6xl font-bold text-white leading-tight mb-8 md:mb-0" style={{ fontFamily: 'Noto Serif KR, serif' }}>
            지금 바로<br />
            시작하세요
          </h2>

          <button
            onClick={() => scrollToSection('contact')}
            className="flex items-center gap-4 md:gap-4 bg-white rounded-full pl-7 md:pl-7 pr-3 md:pr-3 py-3 md:py-3 hover:shadow-2xl transition-all duration-300 cursor-pointer group"
          >
            <span className="text-[#1a2332] font-semibold text-[16px] md:text-lg whitespace-nowrap">
              무료 상담 신청
            </span>
            <div className="w-12 h-12 md:w-12 md:h-12 bg-[#1a2332] rounded-full flex items-center justify-center group-hover:bg-[#ff6b6b] transition-colors duration-300">
              <i className="ri-arrow-right-line text-white text-xl md:text-xl"></i>
            </div>
          </button>
        </div>

        <div className="hidden md:block text-right text-white">
          <p className="text-2xl font-light leading-relaxed">
            1:1 맞춤 상담으로<br />
            최적의 학습 계획을 세워드립니다
          </p>
        </div>
      </div>
    </section>
  );
}
